const isVacr = new RegExp(/virginia|localhost|vacr/,'ig').test(window.location.href);

export default class Config 
{
    public static LOCAL_STORAGE_VERSION_NUMBER = "1.00";
    public static IS_VACR = new RegExp(/virginia|localhost|vacr/,'ig').test(window.location.href);
    public static IS_USCR = !isVacr;

    public static DEFAULT_LOGO_URL = isVacr ? '/vacr.svg' : '/uscr.svg';
    public static APP_TITLE = 'Cybersafe AI';

    public static MAX_SAFE_32_BIT_INTEGER = 2147483647;
    
    // Uis
    public static get CYBERSAFE_UI_BASE_URL()
    {
        return `${window.location.protocol}//${window.location.hostname}:${window.location.port}/`;
    }

    public static LOGIN_UI_BASE_URL = 'http://login.vacr.io:8078';
    public static HOMEPAGE_BASE_URL = 'http://host.vacr.io:8079';

    // External links
    public static KB_BASE_URL = 'https://kb.virginiacyberrange.org';
    public static CYBERSAFE_AI_COURSEWARE_URL = 'https://www.virginiacyberrange.org';
    public static SUPPORT_URL = 'https://www.virginiacyberrange.org/contact-us';
    
    // Apis
    public static AUTHENTICATION_API_BASE_URL = 'http://localhost:8081/';
    public static ENTITLEMENT_API_BASE_URL = 'http://localhost:8082/';
    public static AGREEMENT_API_BASE_URL = 'http://localhost:8093';
    public static COMPETITION_API_BASE_URL = 'http://localhost:8100/';
    public static PLAYER_API_BASE_URL = 'http://localhost:8101/';
    public static TEAM_API_BASE_URL = 'http://localhost:8102/';
    public static CHALLENGE_API_BASE_URL = 'http://localhost:8103/';
    public static SUBMISSION_API_BASE_URL = 'http://localhost:8105/';
    public static FILE_API_BASE_URL = 'http://localhost:8097/';
    public static JOB_API_BASE_URL = 'http://localhost:8109';

    // Matomo
    public static MATOMO_BASE_URL = 'https://analytics.virginiacyberrange.org';
    public static MATOMO_SITE_ID = '9';


    public static async load(remotePath: string): Promise<void> 
    {
        const json = await Config.getFile(remotePath);
        Config.init(json);
    }

    public static async getFile(url: string): Promise<object> 
    {
        let response = await fetch(url);
        return response.ok ? await response.json() : {};
    }

    public static init(json: object) {
        Object.assign(Config, json);
    }
}
